import React, {Component} from 'react';
import Login from "../views/Login";
import Clients from "../views/clients/Clients";
import ClientAccess from "../views/ClientAccess";

class MainRoute extends Component {

    render() {
        return (
            this.props.isAuthenticated ?
                <div>
                    {
                        this.props.isAdmin ?
                            <Clients userData={this.props.userData}/> : <ClientAccess userData={this.props.userData}/>
                    }
                </div>
                :
                <Login onLogin={this.props.onLogin}/>
        );
    }
}

export default MainRoute;


// WEBPACK FOOTER //
// ./src/app/routes/MainRoute.js